import { Grid, GTIWebTextField } from "@gti-controls-v2/web-core";

const ChangePassword = ({ onChangeForm, isLoading, onBlurForm, value }) => {
    const onChange = (e) => {
        if (onChangeForm) {
            onChangeForm(e);
        }
    };

    const onBlur = (e) => {
        if (onBlurForm) {
            onBlurForm(e);
        }
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <GTIWebTextField
                    name="password"
                    type="password"
                    disabled={isLoading}
                    value={value.password}
                    onChange={onChange}
                    labelText="Escribe tu nueva contraseña"
                    placeholder="Escribe tu contraseña"
                    legendText={value.passwordLegend}
                    onBlur={onBlur}
                    width="100%"
                    state={value.passwordState}
                />
            </Grid>
        <Grid item xs={12}>
            <GTIWebTextField
                name="passwordConfirm"
                type="password"
                disabled={isLoading}
                value={value.passwordConfirm}
                onChange={onChange}
                labelText="Vuelve a escribir tu nueva contraseña"
                placeholder="Escribe tu contraseña"
                legendText={value.confirmLegend}
                onBlur={onBlur}
                width="100%"
                state={value.confirmState}
            />
        </Grid>
    </Grid>
    );
};

export default ChangePassword;